export function formatCpfCnpj(value) {
    const digits = value.replace(/\D/g, '');

    if (digits.length <= 11) {
        // CPF: 000.000.000-00
        return digits
            .replace(/^(\d{3})(\d)/, '$1.$2')
            .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/\.(\d{3})(\d)/, '.$1-$2')
            .substring(0, 14);
    } else {
        // CNPJ: 00.000.000/0000-00
        return digits
            .replace(/^(\d{2})(\d)/, '$1.$2')
            .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/\.(\d{3})(\d)/, '.$1/$2')
            .replace(/(\d{4})(\d)/, '$1-$2')
            .substring(0, 18);
    }
}

export function formatPhone(value) {
    if (value) {
        const digits = value.replace(/\D/g, '');

        if (digits.length === 11) {
            // Celular com DDD: (00) 00000-0000
            return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
        } else if (digits.length === 10) {
            // Fixo com DDD: (00) 0000-0000
            return digits.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
        } else if (digits.length === 9) {
            // Celular sem DDD
            return digits.replace(/^(\d{5})(\d{4})$/, '$1-$2');
        } else if (digits.length === 8) {
            // Fixo sem DDD
            return digits.replace(/^(\d{4})(\d{4})$/, '$1-$2');
        }
    }

    return value;
}

export function stripNonDigits(value) {
    return value?.replace(/\D/g, '') || '';
}